import { Loader, SpreadsheetBackground } from '@/components'

export const LoadingScreen = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <SpreadsheetBackground />
      <Loader size="xl" />
    </div>
  )
}
